import { axiosHelper } from './axios-helper';

export const continueLogin = (
  setIsSubmitting: any,
  replace: any,
  setAlertMessage: any,
  clearAlertMessage: any
) => {
  axiosHelper(
    '/account/continueLogin',
    {
      method: 'post',
    },
    setIsSubmitting,
    replace,
    setAlertMessage,
    clearAlertMessage
  )
    .then((payload) => {
      if (payload.isSpaRoute) {
        replace(payload.redirectUrl);
      } else {
        window.location.replace(payload.redirectUrl);
      }
    })
    .catch(() => {});
};
